export default "__VITE_ASSET__CuexF$C3__"